import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { GeneralObSidebar } from "../Layouts/GeneralObSidebar";
import { jsPDF } from "jspdf";
import { Preview, print } from "react-html2pdf";
import ReactToPrint from "react-to-print";

export class GeneralObservations extends Component {
  constructor(props) {
    super(props);

   

    ////
    const url = "";

    this.state = {
      bloodPressure: "",
      temp: "",
      pulseRate: "",
      respirationRate: "",
      weight: "",
      height: "",
      BMI: "",
      randomBloodSugar: "",
      urinalysisProteinuria: "",
      chiefComplaint: "",
      patientName: localStorage.getItem("currentVisitName"),
      currentSpeciality: localStorage.getItem("currentSpecialty"),
      loading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {
    var self = this;
   
    $(".randomBloodSugar").focusout(function () {
      $(".bloodSugarSelect").show();
    });
    $(".selectUnit").click(function () {
      $(".randomBloodSugar").show();
      var currentBloodSugar = self.state.randomBloodSugar;

      var unit = $(this).text();

      self.setState({
        randomBloodSugar: currentBloodSugar + "" + unit,
      });
      console.log(self.state.randomBloodSugar);
    });

    $(".data-entered").click(function () {
      $(".HistoryModal").show();
    });

    $(".height").focusout(function () {
      var weight = parseInt($(".weight").attr("value"));

      var height = parseInt($(".height").attr("value")) / 100;

      var BMI = weight / (height * height);

      var finalBMI = BMI.toString();

      self.setState({
        BMI: finalBMI,
      });

      // alert(self.state.BMI)
      // $(this).attr('value', thisValue+' ')
    });

    $(".printDetails").on("click", function () {
      const doc = new jsPDF({
       
      });
 
    });

    $(".proceed").on("click", function () {
      window.location.href = "/medical/home";
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
  this.setState({
    loading:true
  })
    axios
      .post(
        this.api_url+"" +
          localStorage.getItem("currentModule") +
          "/general/main",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        this.setState({
          loading:false
        })

        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            //
            $(".checkHistory").click();
          }, 1500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "20px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const {
      bloodPressure,
      temp,
      pulseRate,
      respirationRate,
      weight,
      height,
      BMI,
      randomBloodSugar,
      urinalysisProteinuria,
      chiefComplaint,
      patientName,
      loading
    } = this.state;
    return (
      <div>
        <Headers />
        <GeneralObSidebar />

        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-12 font-weight-bold p-1">
                <p className="text-capitalize" style={font16}>
                  General Observations
                </p>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      {" "}
                      Chief Complaint
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={chiefComplaint}
                      name="chiefComplaint"
                      required
                    ></textarea>
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Blood Pressure(mmgh)
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={bloodPressure}
                      name="bloodPressure"
                      type="number"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Temp(degree celsius)
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={temp}
                      name="temp"
                      type="number"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Respiration Rate (b/min)
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={respirationRate}
                      name="respirationRate"
                      type="number"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Weight (Kg)
                    </h6>
                    <input
                      className="form-control weight"
                      onChange={this.handleChange}
                      value={weight}
                      name="weight"
                      type="number"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Height (cm)
                    </h6>
                    <input
                      className="form-control height"
                      onChange={this.handleChange}
                      value={height}
                      name="height"
                      type="number"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      BMI
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={BMI}
                      name="BMI"
                      type="text"
                      readOnly="readOnly"
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Pulse Rate
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={pulseRate}
                      name="pulseRate"
                      type="number"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Random Blood Sugar
                    </h6>

                    <input
                      className="form-control randomBloodSugar"
                      onChange={this.handleChange}
                      value={randomBloodSugar}
                      name="randomBloodSugar"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1 bloodSugarSelect" style={displayHidden}>
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Random Blood Sugar Unit
                    </h6>
                    <select className="form-control" required>
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="mmol/l" className="selectUnit">
                          {" "}
                          Mmol/L
                        </option>
                        <option value=" mg/d" className="selectUnit">
                          {" "}
                          Mg/dl
                        </option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Urinalysis for Proteinuria
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={urinalysisProteinuria}
                      name="urinalysisProteinuria"
                    >
                      <optgroup label="Urinalysis for Proteinuria">
                        <option selected disabled></option>
                        <option value="positive">Positive</option>
                        <option value="negative">Negative</option>
                        <option value="notDone">Not Done</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>

             <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>General Observations Saved
                Successfully.
              </div>


              <div
                className="modal HistoryModal"
                style={autoscroll}
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {" "}
                        {patientName}`s General Observation Modal
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {/* <div className="py-1">
                            <h6 className="text-capitalize" style={ fontFamilyNunito }>Name</h6><input className="form-control"   type="text" required/>
                        </div> */}

                      {/* <ReactToPrint
          trigger={() => {
            return <a className="btn btn-success printDetails" style={width100} href="#">Download PDF</a>;
          }}
          bodyClass='jsx-template'
        /> */}
                      <a
                        className="btn btn-success printDetails"
                        style={width100}
                        onClick={this.PrintWindow}
                      >
                        Download
                      </a>
                      <br />
                      <a className="btn btn-danger proceed" style={width100}>
                        Proceed to Dashboard
                      </a>
                      <div class="jsx-template">
                        <b>NAME: </b>
                        {patientName}
                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            {" "}
                            Chief Complaint
                          </h6>
                          <textarea
                            className="form-control"
                            readOnly
                            value={chiefComplaint}
                            name="chiefComplaint"
                            required
                          ></textarea>
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Blood Pressure(mmgh)
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={bloodPressure}
                            name="bloodPressure"
                            type="number"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Temp(degree celsius)
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={temp}
                            name="temp"
                            type="number"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Respiration Rate (b/min)
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={respirationRate}
                            name="respirationRate"
                            type="number"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Weight (Kg)
                          </h6>
                          <input
                            className="form-control weight"
                            readOnly
                            value={weight}
                            name="weight"
                            type="number"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Height (cm)
                          </h6>
                          <input
                            className="form-control height"
                            readOnly
                            value={height}
                            name="height"
                            type="number"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            BMI
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={BMI}
                            name="BMI"
                            type="text"
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Pulse Rate
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={pulseRate}
                            name="pulseRate"
                            type="number"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Random Blood Sugar
                          </h6>

                          <input
                            className="form-control randomBloodSugar"
                            onChange={this.handleChange}
                            value={randomBloodSugar}
                            name="randomBloodSugar"
                            type="number"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Urinalysis for Proteinuria
                          </h6>
                          <input
                            type="text"
                            className="form-control"
                            readOnly
                            value={urinalysisProteinuria}
                            name="urinalysisProteinuria"
                          />
                        </div>

                        <div className="row">
                          {/* <div  className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                          {/* <div className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold" type="submit" style={floatLeft}>Submit</button></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                {/* <a className="btn btn-primary checkHistory" style={displayHidden}>Check Patient History</a> */}
                {/* <div  className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold data-entered" type="button" style={floatRight}>See the Data Entered</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                   {loading ? 'Loading' : 'Submit'} 
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default GeneralObservations;
